import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { useEmployee } from '../../hooks/useEmployees';
import EmployeeForm from './form';
/**
 * Edit Employee Page
 */
export default function EditEmployee() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data: employee, isLoading, error } = useEmployee(id);
    if (isLoading) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen", children: _jsxs("div", { className: "text-center", children: [_jsx(Loader2, { className: "h-12 w-12 animate-spin text-brand-600 mx-auto mb-4" }), _jsx("p", { className: "text-gray-600", children: "Loading employee..." })] }) }));
    }
    if (error || !employee) {
        return (_jsx("div", { className: "max-w-4xl mx-auto px-4 py-8", children: _jsxs("div", { className: "bg-red-50 border border-red-200 rounded-lg p-6", children: [_jsx("h2", { className: "text-red-800 font-semibold mb-2", children: "Error Loading Employee" }), _jsx("p", { className: "text-red-600", children: error?.message || 'Employee not found' }), _jsx("button", { onClick: () => navigate('/people'), className: "mt-4 text-red-700 underline hover:text-red-900", children: "Back to Employee List" })] }) }));
    }
    return _jsx(EmployeeForm, { mode: "edit", employee: employee });
}
